import React, {useEffect, useState} from "react";
import {Button, Divider, Stack, Typography} from "@mui/material";
import {dataManager} from "../../../Broadtask";
import {useNavigate} from "react-router-dom";
import {RefreshOutlined} from "@mui/icons-material";
import NetworkProcessCard from "./NetworkProcessCard";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import GridViewIcon from "@mui/icons-material/GridView";
import {buttonStyle, sectionStack} from "../../../../AppStyles";

const NetworkProcessSelectPane = (props) => {

    const navigate = useNavigate();
    const [processes, setProcesses] = useState(null);

    useEffect(() => {
        reload(false);
    }, []);

    function reload(force)
    {
        dataManager.getNetworkManager().getInstance(props.networkUID).getProcesses(force, (processes) => {
            setProcesses(processes);
        });
    }

    function onRefresh()
    {
        reload(true);
    }

    function onView()
    {
        navigate("../networks/" + props.networkUID + "/processes");
    }

    function onAdd()
    {
        navigate("../networks/" + props.networkUID + "/processes/add");
    }


    return (
        <Stack direction="column" spacing={1} padding={1} width="100%"
               alignItems="flex-start" justifyContent="flex-start"
               sx={sectionStack}>
            <Stack direction="row" width="100%"
                   justifyContent="space-between"
                   padding={1} spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <img src="/icons/process.png" width={32} height={32}/>
                    <Typography variant="h6">Processes</Typography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Button onClick={onRefresh} title="Refresh"
                            sx={buttonStyle}
                            startIcon={<RefreshOutlined />}>REFRESH</Button>
                    <Button onClick={onAdd}
                            sx={buttonStyle}
                            startIcon={<AddCircleOutlineIcon />}>ADD</Button>
                    <Button onClick={onView}
                            sx={buttonStyle}
                            startIcon={<GridViewIcon />}>VIEW</Button>
                </Stack>
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
            <Stack direction="row" spacing={1} padding={1} width="100%" minHeight={100}
                   useFlexGap sx={{ flexWrap: "wrap", backgroundColor: '#2A333A'}}>
            {
                processes === null ?
                    <Typography variant="h6">Loading...</Typography>:
                    processes.map(nextProcess => {
                        return (<NetworkProcessCard networkUID={props.networkUID} key={"process_" + nextProcess.processUID} entry={nextProcess} />)
                    })
            }
            </Stack>
            <Divider orientation="horizontal" variant="left" flexItem />
        </Stack>
    );
}

export default NetworkProcessSelectPane;
